const positiveStoreId = value => {
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export function resolveConversationUserStoreId(user, users = []) {
  return positiveStoreId(user?.storeId)
    || positiveStoreId(users.find(candidate => Number(candidate.id) === Number(user?.id))?.storeId);
}

export function resolveConversationRecordStoreId(record, users = []) {
  return positiveStoreId(record?.storeId)
    || positiveStoreId(users.find(candidate => Number(candidate.id) === Number(record?.consultantId))?.storeId);
}

export function conversationRecordIsInUserStore(record, user, users = []) {
  if (user?.role === "admin") return true;
  const userStoreId = resolveConversationUserStoreId(user, users);
  return userStoreId != null
    && resolveConversationRecordStoreId(record, users) === userStoreId;
}

export function conversationConsultantsInScope(user, users = []) {
  if (!user || !["admin", "manager"].includes(user.role)) return [];
  const userStoreId = resolveConversationUserStoreId(user, users);
  return users.filter(candidate => (
    candidate.role === "consultant"
    && (user.role === "admin" || positiveStoreId(candidate.storeId) === userStoreId)
  ));
}